export const business = {
  name: 'Bucket Hat Cleaning LLC',
  owner: 'Mason Orr',
  tagline: 'Your Local Exterior Cleaner',
  phone: '402-417-0003',
  phoneHref: 'tel:+14024170003',
  email: 'mason@buckethatcleaning.com',
  website: 'BucketHatCleaning.com',
  city: 'Lincoln, Nebraska',
  hours: 'Mon–Sat, 8am–7pm',
  logoFull:
    'https://cdn.magicpatterns.com/uploads/5iEvsVQsBWaVtVBPqTpCNy/image.png',
  logoBadge:
    'https://cdn.magicpatterns.com/uploads/gAdbXVaf9rwC1F2dUL4jAv/image.png',
  businessCard:
    'https://cdn.magicpatterns.com/uploads/cFmobzXvfm2giDshJF4t6h/image.png',
  masonPhoto:
    'https://cdn.magicpatterns.com/uploads/8R8Lax4GFgRDPeffSsaqR4/Screenshot_2026-08-24_174445.png'
}

export const serviceAreas = [
  'Lincoln',
  'Waverly',
  'Hickman',
  'Eagle',
  'Crete',
  'Seward',
  'Milford',
  'Denton',
  'Roca',
  'Bennet',
  'Malcolm',
  'Ceresco'
]
